import React from 'react'
import './Footer.css'

function footer() {
    return(
		<footer className="footer">
		    <div className="footer-container">
		    	<div className="footer-row">
		    		<div className="sponsors">
             			<h2>We thank our sponsors:</h2>
		    		<hr/>
		    		</div>
		    	</div>

				<div className="footer-row">
					<div className="sponsor-images">
		    			<a href="https://novonordiskfonden.dk/en/" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/nnf.png" alt="Novo Nordisk Fonden"/></a>
					</div>
					<div className="sponsor-images">
		    			<a href="https://www.twistbioscience.com" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/twist.png" alt="Twist Bioscience"/></a>
					</div>
					<div className="sponsor-images">
		    			<a href="https://eu.idtdna.com/" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/idt.png" alt="IDT"/></a>
					</div>
					<div className="sponsor-images">
		    			<a href="https://ampliqon.com" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/ampliqon.png" alt="Ampliqon"/></a>
					</div>
             		<div className="sponsor-images">
		    			<a href="https://www.snapgene.com/" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/snapgene.png" alt="Snapgene"/></a>
		    		</div>
					<div className="sponsor-images">
		    			<a href="https://ida.dk" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/ida.png" alt="IDA"/></a>
					</div>
					<div className="sponsor-images">
		    			<a href="https://www.bionordika.se" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/bionordika.png" alt="BioNordika"/></a>
					</div>
					<div className="sponsor-images">
		    			<a href="https://www.snabslanten.kk.dk" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/snabslanten.png" alt="Snabslanten"/></a>
					</div>
					<div className="sponsor-images">
		    			<a href="https://rctech.com" target="_blank" rel="noreferrer"><img src="https://static.igem.wiki/teams/4247/wiki/impact-grant.png" alt="Snabslanten"/></a>
					</div>
		    	</div>
		    	<div className="footer-row">
		    		<hr/>
		    	</div>
		    	<div className="footer-row">
		    		<div className="footer-col">
		    			<h4>About us</h4>
		    			<p>A team of 9 students ftom the University of Copenhagen tackling the issues caused nylon fishing nets with synthetic biology</p>		
		    		</div>
		    		<div className="footer-col">
		    			<h4>Address</h4>
		    			<p>University of Copenhagen
		    				<br/>
		    				Thorvaldsensvej 40, Frederiksberg C
		    				<br/>				
		    				Denmark</p>
		    		</div>
		    		<div className="footer-col">
		    			<h4>follow us</h4>
		    			<div className="social-links">
		    				<a href="https://www.facebook.com/iGEMCopenhagen" target="_blank" rel="noreferrer"><i className="bi bi-facebook"></i></a>
		    				<a href="https://twitter.com/iGEM_Copenhagen" target="_blank" rel="noreferrer"><i className="bi bi-twitter"></i></a>
		    				<a href="https://www.instagram.com/igem_copenhagen/" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a>
		    				<a href="https://www.linkedin.com/company/igemucph" target="_blank" rel="noreferrer"><i className="bi bi-linkedin"></i></a>
		    			</div>
		    			<h4>Contact us</h4>
		    			<div className="social-links">
		    				<a target="_top" href="mailto:ucph.igem2022@gmail.com?subject = iGEM UCopenhagen inquiry"><i className="bi bi-envelope-open-fill"></i></a>
		    				<p>igem.ucph2022@gmail.com</p>
		    			</div>
		    		</div>
		    	</div>
		    	<div className="footer-row mt-4">
		    		<div className="col">
		    			<p className="mb-0"><small>© 2022 - Content on this site is licensed under a <a className="subfoot" href="https://creativecommons.org/licenses/by/4.0/" rel="license">Creative Commons Attribution 4.0 International license</a>.</small></p>
		    			<p><small>The repository used to create this website is available at <a href="https://gitlab.igem.org/2022/ucopenhagen">gitlab.igem.org/2022/ucopenhagen</a>.</small></p>
		    		</div>
    	    	</div>		
		    </div>	
        </footer>

    )
}

export default footer